<template>
  <div id="match-make-group">
    <comp-header
      :pageTitle="headerPageTitle"
      :leftIcon="headerLeftIcon"
      :leftClick="headerLeftAction"
      :rightIcon="headerRightIcon"
      :rightClick="headerRightAction"
    />
    <table class="form-table">
      <tr>
        <td>
          <form-input
            id="group-name"
            :placeholderText="groupNameHolder"
            :inputType="typeText"
            :inputValue="groupName"
            :showInfo="true"
            @inputParent="value => updateGruopName(value)"
          />
        </td>
      </tr>
    </table>

    <comp-modal v-if="showErrorModal" @confirm="showErrorModal = false">
      <p slot="body">{{ errorMsg }}</p>
    </comp-modal>
  </div>
</template>

<script>
import common from '@/utils/common';
import CompHeader from '@/components/CompHeader';
import FormInput from '@/components/FormInput';
import RESPONSE from '@/constants/response';

export default {
  name: 'match-make-group',
  mixins: [common],
  components: {
    CompHeader,
    FormInput,
  },
  data() {
    return {
      headerPageTitle: this.$i18n.t('matchManage.makeGroup'),
      headerLeftIcon: 'fa-chevron-left',
      headerRightIcon: '',

      typeText: 'text',
      showErrorModal: false,
      errorMsg: '',

      groupNameHolder: this.$i18n.t('match.makeGroupPlaceholder'),

      groupName: '',
    };
  },
  methods: {
    headerLeftAction() {
      this.goPrevious();
    },
    headerRightAction() {
      if (this.groupName) {
        const groupName = this.groupName;
        this.$store.dispatch('createGroup', { groupName }).then((data) => {
          if (data.status === RESPONSE.TOKEN_EXPIRED.CODE) {
            this.$store.dispatch('refreshToken').then((response) => {
              if (response.status === RESPONSE.SUCCESS.CODE) {
                this.headerRightAction();
              } else {
                this.invalidateLogin();
              }
            });
          } else if (Object.prototype.hasOwnProperty.call(data, 'data')) {
            this.$router.push({
              name: 'match-list',
              params: {
                redirectInvitePage: true,
                groupId: data.data.groupId,
                groupName: data.data.groupName,
              },
            });
          } else {
            this.errorMsg = this.$i18n.t('error.undefined');
            this.showErrorModal = true;
          }
        });
      }
    },
    updateGruopName(value) {
      this.groupName = value;
      this.headerRightIcon = this.groupName ? 'fa-arrow-right' : '';
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/match/match-make-group.vue